// "Show only my blueprints" is a BACKEND filter (bd zh7jq), so the list API
// returns only the current page (ordered by created_at server-side). We sort
// the page rows client-side by updatedAt DESC (most-recently-updated first).
export function sortByUpdatedDesc<T extends {updatedAt: string}>(rows: T[]): T[] {
    return [...rows].sort(
        (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
    );
}
